import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDropDownComponent, MatDropDownTriggerDirective } from './mat-drop-down.component';

@NgModule({
  imports: [CommonModule, OverlayModule, MatOptionModule],
  exports: [MatFormFieldModule, MatDropDownComponent, MatOptionModule, MatDropDownTriggerDirective],
  declarations: [MatDropDownComponent, MatDropDownTriggerDirective],
})
export class MatDropDownModule {}
